import { OnInit, OnDestroy, Directive } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { DashpivotEvent, EventNotifierService, EventTypes } from '@site-mate/dashpivot-shared-library';

import { appControlType } from 'app/apps/app-control-type.model';
import { SegmentService } from 'app/segment/segment.service';
import { TemplateRouteContext } from 'app/shared/model/template-route-context.model';
import { ErrorHandler } from 'app/shared/service/error-handler.service';
import { RouteParamsService } from 'app/shared/service/route-params.service';
import { TimingMarkerService } from 'app/shared/service/timing-marker.service';

@Directive()
export class TemplateFormsBaseComponent implements OnInit, OnDestroy {
  controlType = appControlType;
  templateId;
  formId;
  app;
  private unSubscribe = new Subject<void>();
  canAdd = true;

  public context: TemplateRouteContext;

  constructor(
    protected readonly route: ActivatedRoute,
    protected readonly router: Router,
    protected readonly errorHandler: ErrorHandler,
    protected readonly routeParamsService: RouteParamsService,
    protected readonly timingMarkerService: TimingMarkerService,
    protected readonly segmentService: SegmentService,
  ) {}

  ngOnInit(): void {
    this.templateId = this.route.snapshot.paramMap.get('templateId');
    this.context = this.route.parent.snapshot.data.context;

    if (this.context === TemplateRouteContext.Library) {
      this.canAdd = false;
    }

    this.routeParamsService
      .get('template')
      .pipe(filter((template) => !!template))
      .subscribe(
        (template: any) => {
          this.app = template;
          this.canAdd = this.canAdd && !template.isOrganisationTemplate;
        },
        (error) => {
          this.errorHandler.handle(error);
        },
      );
  }

  protected trackViewedEvent(view): void {
    void EventNotifierService.notify(
      new DashpivotEvent(EventTypes.FormListViewed, { Context: view }),
      this.segmentService,
    );
  }

  ngOnDestroy(): void {
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }

  onAddForm(): void {
    void this.router.navigate(['new'], {
      relativeTo: this.route,
      queryParamsHandling: 'merge',
    });
  }
}
